<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form :model="queryParams" ref="queryParams" size="small" label-width="120px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="4">
              <el-form-item label="派单状态">
                <el-select v-model="queryParams.orderState" placeholder="请选择派单状态" clearable multiple collapse-tags>
                  <el-option label="未派单" value="1" />
                  <el-option label="预派单" value="4" />
                  <el-option label="派单未接收" value="0" />
                  <el-option label="派单已接收" value="3" />
                  <el-option label="已撤消" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="计划检测时间">
                <el-date-picker v-model="queryParams.estimatedDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                clearable style="width:100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="实际检测时间">
                <el-date-picker v-model="queryParams.receivedDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                clearable style="width:100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="检测员">
                <el-select v-model="queryParams.employeePids" placeholder="请选择检测员" clearable multiple collapse-tags filterable>
                  <el-option v-for="employee in searchEmployeeList" :key="employee.employeePid" :label="employee.employeeName" :value="employee.employeePid" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="客户名称">
                <div class="customer-input-wrap">
                  <el-input v-model="queryParams.compNames" placeholder="请输入使用单位" />
                  <CustomerDetails v-model="queryParams.compNames" />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="right">

            <el-col :span="4">
              <el-form-item label="识别码">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="小区名称">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="年检月份" prop="inspectionMonthList">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择年检月份" value-format="yyyy-MM" clearable style="width: 100%;"  />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="现场联系人/电话">
                <el-input v-model="queryParams.siteContact" placeholder="请输入现场联系人" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label-width="0px">
                <el-input v-model="queryParams.siteContactTel" placeholder="请输入现场电话" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="right">

            <!-- <el-col :span="4">
              <el-form-item label="设备使用地址">
                <el-input v-model="queryParams.EQP_AREA_NAME" placeholder="请输入设备所在辖区" clearable />
              </el-form-item>
            </el-col> -->
            <el-col :span="4">
              <el-form-item label="使用单位名称">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="业务联系人/电话">
                <el-input v-model="queryParams.businessContact" placeholder="请输入业务联系人" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label-width="0px">
                <el-input v-model="queryParams.businessContactTel" placeholder="请输入业务电话" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域选择">
                <ChinaAreaCascader :multiple="true" :checkStrictly="true" width="100%" v-model="areaSelectedValue" />
              </el-form-item>
            </el-col>

          </el-row>
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleAdd="handleAdd" @handleDispatchSingle="handleDispatchSingle"
                                     @handlePreDispatchSingle="handlePreDispatchSingle" @handleCancelSingle="handleCancelSingle" @handleDownloads="handleDownloads" />
          </div>
          <!-- 添加遮罩层和加载状态的表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" v-loading="loading" element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" @selection-change="handleSelectionChange" height="500">
            <el-table-column type="selection" width="55" fixed="left"></el-table-column>
            <el-table-column label="序号" type="index" width="50" fixed="left" :index="indexMethod" />
            <el-table-column label="客户名称" prop="compName" width="150" show-overflow-tooltip fixed="left" />
            <el-table-column label="使用单位名称" prop="usingUnit" width="180" show-overflow-tooltip />
            <el-table-column label="小区名称" prop="houseName" width="140" show-overflow-tooltip />
            <el-table-column label="现场联系人及电话" width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.siteContact }}/{{ scope.row.siteContactTel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="业务联系人及电话" width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.businessContact }}/{{ scope.row.businessContactTel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="最近安改监检日期" prop="lastMonDate" width="140" show-overflow-tooltip />
            <el-table-column label="识别码" prop="OIDNO" width="100" show-overflow-tooltip />
            <el-table-column label="使用区域" prop="EQP_AREA_NAME" width="120" show-overflow-tooltip />
            <el-table-column label="使用地址" prop="EQP_USE_ADDR" width="200" show-overflow-tooltip />
            <el-table-column label="年检月份" prop="inspectionMonth" width="90" />
            <el-table-column label="计划检测时间" prop="estimatedDate" width="110" />
            <el-table-column label="检测员" prop="employeeName" width="100" show-overflow-tooltip >
              <template slot-scope="scope">
                <span>{{ scope.row.employeeName || scope.row.employeeNames }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实际检测时间" prop="receivedDate" width="110" >
              <!-- <template slot-scope="scope">
                <span v-if="scope.row.orderState === '3'">{{ scope.row.reportDate }}</span>
                <span v-else>-</span>
              </template> -->
            </el-table-column>
            <el-table-column label="设备类别" prop="EQP_TEMP_NAME" width="180" show-overflow-tooltip />
            <el-table-column label="制造单位" prop="MAKE_UNT_NAME" width="150" show-overflow-tooltip />
            <el-table-column label="层数/高度/长度" prop="ELEFLOORNUMBER" width="120" />
            <el-table-column label="备注" prop="remark" width="150" show-overflow-tooltip />
            <el-table-column label="状态" prop="orderState" width="100">
              <template slot-scope="scope">
                <el-tag :type="getOrderStateType(scope.row.orderState)">
                  {{ getOrderStateText(scope.row.orderState) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="委托单编号" prop="entrustNum" width="180" show-overflow-tooltip />
            <!-- <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)"  />
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination v-show="totalRowNum > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage"
                         :page-sizes="[10, 20, 50, 100,200,500,1000]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRowNum"
                         style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 新增/修改弹出层 -->
    <!-- <AddAndEdit ref="addAndEdit" @refresh="handleQuery" /> -->

    <!-- 派单弹出层 -->
    <el-dialog :title="isPreDispatch ? '预派单' : '派单'" :visible.sync="dispatchDialogVisible" width="600px" :before-close="closeDispatchDialog">
      <el-form :model="dispatchForm" ref="dispatchForm" label-width="120px" :rules="dispatchRules">
        <el-form-item label="委托号">
          <el-input v-model="dispatchForm.entrustNum" disabled />
        </el-form-item>
        <!-- 预检日期：始终显示，选填 -->
        <el-form-item label="预检日期" prop="estimatedDate">
          <el-date-picker v-model="dispatchForm.estimatedDate" type="date" placeholder="选择预计日期" value-format="yyyy-MM-dd" style="width: 100%;" :picker-options="datePickerOptions" />
        </el-form-item>
        <el-form-item label="派单日期" prop="orderDate">
          <el-date-picker v-model="dispatchForm.orderDate" type="date" placeholder="选择派单日期" value-format="yyyy-MM-dd" style="width: 100%;" :picker-options="datePickerOptions" />
        </el-form-item>
        <el-form-item label="检测员" prop="employeePids" v-if="!isPreDispatch">
          <el-select v-model="dispatchForm.employeePids" multiple placeholder="请选择职员" style="width: 100%;" :loading="employeeLoading">
            <el-option v-for="employee in employeeList" :key="employee.employeePid" :label="employee.employeeName" :value="employee.employeePid" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDispatchDialog">取 消</el-button>
        <el-button type="primary" @click="confirmDispatch" :loading="dispatchLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryAllEntrustTask, exportEntrustTask, queryEmployee, saveEntrustTask, dispatchTask, backEntrustTask } from '@/api/contract/contract'
// import AddAndEdit from './AddAndEdit.vue'
import ChinaAreaCascader from '@/components/ChinaAreaCascader/index.vue';
export default {
  components: {
    ChinaAreaCascader
  },
  props: {
    url: {
      type: String
    }
  },
  data () {
    return {
      queryParams: {
        inspectionMonthList: [],
        usingUnit: '',
        houseName: '', // 小区名称
        EQP_AREA_NAME: '',
        orderState: ["1"],
        employeePids: [], // 检测员多选，初始化为数组
        currPage: 1,
        pageSize: 1000
      },
      areaSelectedValue: [], // ChinaAreaCascader 多选值
      tableData: [], // 这里将填充从API获取的数据
      totalRowNum: 0,
      loading: false,
      selectedRows: [], // 选中的行数据
      dispatchDialogVisible: false, // 派单弹窗显示状态
      dispatchForm: {
        entrustNum: '',
        entrustNumArray: [], // 用于提交的数组格式
        estimatedDate: '',
        orderDate: '',
        employeePids: []
      },
      dispatchRules: {
        estimatedDate: [
          { required: true, message: '请选择预计日期', trigger: 'change' }
        ],
        orderDate: [
          { required: true, message: '请选择派单日期', trigger: 'change' }
        ],
        employeePids: [
          { required: true, message: '请选择职员', trigger: 'change' }
        ]
      },
      dispatchLoading: false,
      employeeList: [], // 职员列表（用于派单弹窗）
      searchEmployeeList: [], // 职员列表（用于搜索条件）
      employeeLoading: false, // 职员加载状态
      isPreDispatch: false, // 是否为预派单模式
      originalEstimatedDate: '', // 原始预计检测日期（用于检测用户是否修改）
      hasMultipleDates: false, // 是否有多个不同的预计检测日期
      preDispatchDateList: [], // 预派单日期列表
      isMixedDispatch: false, // 是否为混合派单
      isAllPreDispatch: false, // 是否全是预派单
      // 日期选择器配置：禁止选择今天之前的日期
      datePickerOptions: {
        disabledDate (time) {
          // 获取今天的开始时间（0点0分0秒）
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          return time.getTime() < today.getTime()
        }
      }
    };
  },
  created () {
    //this.handleQuery()
    // 页面加载时查询所有员工列表用于搜索条件
    this.loadAllEmployees()
  },
  watch: {
    areaSelectedValue (newVal) {
      this.handleAreaChange(newVal)
    },
    // 监听预计检测日期变化（仅在正式派单且有多个不同日期时）
    'dispatchForm.estimatedDate' (newVal, oldVal) {
      if (!this.isPreDispatch && this.hasMultipleDates && this.originalEstimatedDate && newVal !== this.originalEstimatedDate) {
        this.$message.warning('预计检测日期不同')
      }
    }
  },
  methods: {
    // 计算序号（考虑分页）
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1
    },
    handleSearch () {
      // 搜索时重置到第一页
      this.queryParams.currPage = 1
      this.handleQuery()
    },
    handleQuery () {
      // 开始查询时显示加载状态
      this.loading = true

      // 使用完整的queryParams参数，包含分页信息
      const params = { ...this.queryParams }

      // 过滤空值，但保留分页参数
      Object.keys(params).forEach(key => {
        // 过滤空字符串、空数组、null、undefined
        if ((params[key] === '' || (Array.isArray(params[key]) && params[key].length === 0) || params[key] === null || params[key] === undefined) && key !== 'currPage' && key !== 'pageSize') {
          delete params[key]
        }
      })

      queryAllEntrustTask(params)
        .then(res => {
          if (res) {
            this.tableData = res.dataList || []
            this.totalRowNum = res.totalRowNum || this.tableData.length
          } else {
            this.$message.error(res.retMsg || '查询失败')
            this.tableData = []
            this.totalRowNum = 0
          }
          this.loading = false
        })
        .catch(err => {
          this.$message.error('查询失败：' + (err.message || '网络错误'))
          this.tableData = []
          this.totalRowNum = 0
          this.loading = false
        })
    },
    // 切换每页条数
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.handleQuery()
    },
    // 切换页码
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.handleQuery()
    },

    handleAdd () {
      // 新增逻辑
      this.$refs.addAndEdit.showAdd()
    },
    getDisabledButtons (row) {
      let disabledButtons = []
      if (row.orderState === '0' || row.orderState === '3') {
        disabledButtons.push('handleDispatchSingle')
      }
      // if (row.orderState === '1' || row.orderState === '2') {
      //   disabledButtons.push('handleCancelSingle')
      // }
      return disabledButtons
    },

    // 获取派单状态文本
    getOrderStateText (state) {
      const stateMap = {
        '0': '派单未接收',
        '1': '未派单',
        '2': '已撤消',
        '3': '派单已接收',
        '4': '预派单',
      }
      return stateMap[state] || '未知状态'
    },
    // 获取派单状态标签类型
    getOrderStateType (state) {
      const typeMap = {
        '0': 'success',
        '1': 'warning',
        '2': 'danger',
        '3': 'info',
        '4': 'success',
      }
      return typeMap[state] || 'info'
    },
    // 处理派单
    handleDispatchSingle () {
      // 判断是否有勾选数据
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请至少勾选一条数据进行派单')
        return
      }

      // 检查是否有已派单的数据 (orderState === '0')
      const hasDispatched = this.selectedRows.some(row => row.orderState === '0')
      if (hasDispatched) {
        this.$message.warning('有已派单的数据，请确认后重试')
        return
      }

      // 获取所有不同的报告类型
      const configReportPids = [...new Set(this.selectedRows.map(row => row.configReportPid).filter(pid => pid))]
      if (configReportPids.length === 0) {
        this.$message.warning('选中的委托单缺少报告类型信息，无法派单')
        return
      }

      // 提取所有勾选数据的委托号
      const entrustNums = this.selectedRows.map(row => row.entrustNum)

      // 获取当前日期，格式化为 yyyy-MM-dd
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      const todayStr = `${year}-${month}-${day}`

      // 检查选中数据中的预派单记录和未预派单记录
      const preDispatchedRows = this.selectedRows.filter(row => row.orderState === '4')
      const noPreDispatchedRows = this.selectedRows.filter(row => row.orderState !== '4')
      const estimatedDates = [...new Set(preDispatchedRows.map(row => row.estimatedDate).filter(date => date))]

      // 判断派单场景
      const hasPreDispatch = preDispatchedRows.length > 0
      const hasNoPreDispatch = noPreDispatchedRows.length > 0
      const isMixedDispatch = hasPreDispatch && hasNoPreDispatch // 混合派单
      const isAllPreDispatch = hasPreDispatch && !hasNoPreDispatch // 全是预派单
      const isAllNoPreDispatch = !hasPreDispatch && hasNoPreDispatch // 全是未预派单

      let defaultEstimatedDate = ''
      this.hasMultipleDates = estimatedDates.length > 1
      this.isMixedDispatch = isMixedDispatch
      this.isAllPreDispatch = isAllPreDispatch

      if (isMixedDispatch && this.hasMultipleDates) {
        // 情况5：混合派单 + 预派单有多个不同日期 - 前端提示，后端会阻止
        this.$message.warning('选中的预派单设备有不同的预检日期，与未预派单设备不能一起派单！')
      } else if (isMixedDispatch && estimatedDates.length === 1) {
        // 情况3/4：混合派单 + 预派单只有一个日期
        defaultEstimatedDate = estimatedDates[0]
        this.$message.info('未预派单设备将使用预派单日期：' + defaultEstimatedDate)
      } else if (isAllPreDispatch && this.hasMultipleDates) {
        // 情况2：全是预派单 + 不同日期 - 预检日期选填，不填则保留各自日期
        defaultEstimatedDate = ''
      } else if (isAllPreDispatch && estimatedDates.length === 1) {
        // 情况1：全是预派单 + 相同日期 - 预检日期选填，不填则使用预派单日期
        defaultEstimatedDate = estimatedDates[0]
      } else if (isAllNoPreDispatch) {
        // 情况6/7：全是未预派单 - 需要用户选择日期
        defaultEstimatedDate = ''
      }

      // 用逗号隔开显示在委托号字段中
      this.dispatchForm.entrustNum = entrustNums.join(',')
      this.dispatchForm.entrustNumArray = entrustNums // 保存数组格式用于提交
      this.dispatchForm.estimatedDate = defaultEstimatedDate
      this.dispatchForm.orderDate = todayStr // 设置派单日期为当天
      this.dispatchForm.employeePids = []

      // 标记为正式派单模式
      this.isPreDispatch = false

      // 动态修改验证规则
      this.updateDispatchRules()

      // 根据报告类型查询有权限的员工（支持多个报告类型，查询交集）
      this.loadEmployeeListByReports(configReportPids)

      this.dispatchDialogVisible = true
    },
    handleDownloads () {
      const params = { ...this.queryParams }
      Object.keys(params).forEach(key => {
        if ((params[key] === '' || (Array.isArray(params[key]) && params[key].length === 0) || params[key] === null || params[key] === undefined) && key !== 'currPage' && key !== 'pageSize') {
          delete params[key]
        }
      })
      this.$message.info('正在导出，请稍候…')
      exportEntrustTask(params)
        .then(blob => {
          const fileBlob = new Blob([blob], { type: blob.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = window.URL.createObjectURL(fileBlob)
          const link = document.createElement('a')
          link.href = url
          link.download = '派单任务导出.xlsx'
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch(err => {
          this.$message.error('导出失败：' + (err.message || '网络错误'))
        })
    },
    // 预派单
    handlePreDispatchSingle () {
      // 判断是否有勾选数据
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请至少勾选一条数据进行预派单')
        return
      }

      // 检查是否有已派单的数据 (orderState === '0')
      const hasDispatched = this.selectedRows.some(row => row.orderState === '0')
      if (hasDispatched) {
        this.$message.warning('有已派单的数据，请确认后重试')
        return
      }

      // 获取所有不同的报告类型
      const configReportPids = [...new Set(this.selectedRows.map(row => row.configReportPid).filter(pid => pid))]
      if (configReportPids.length === 0) {
        this.$message.warning('选中的委托单缺少报告类型信息，无法预派单')
        return
      }

      // 提取所有勾选数据的委托号
      const entrustNums = this.selectedRows.map(row => row.entrustNum)

      // 获取当前日期，格式化为 yyyy-MM-dd
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      const todayStr = `${year}-${month}-${day}`

      // 用逗号隔开显示在委托号字段中
      this.dispatchForm.entrustNum = entrustNums.join(',')
      this.dispatchForm.entrustNumArray = entrustNums // 保存数组格式用于提交
      this.dispatchForm.estimatedDate = ''
      this.dispatchForm.orderDate = todayStr // 设置派单日期为当天
      this.dispatchForm.employeePids = []

      // 标记为预派单模式
      this.isPreDispatch = true
      this.originalEstimatedDate = ''
      this.hasMultipleDates = false
      this.preDispatchDateList = [] // 预派单模式不显示日期列表
      this.isMixedDispatch = false
      this.isAllPreDispatch = false

      // 动态修改验证规则：预派单时人员非必填
      this.updateDispatchRules()

      // 预派单也根据报告类型查询有权限的员工（支持多个报告类型，查询交集）
      this.loadEmployeeListByReports(configReportPids)

      this.dispatchDialogVisible = true
    },
    handleCancelSingle () {
      // 判断是否有勾选数据
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请至少勾选一条数据进行撤销')
        return
      }

      // 检查选中的数据中是否存在状态为 1（未派单）或 2（已撤消）的记录
      const invalidRows = this.selectedRows.filter(row => row.orderState === '1' || row.orderState === '2')
      if (invalidRows.length > 0) {
        this.$message.warning('选中的数据中包含未派单或已撤消的记录，不能进行撤销操作')
        return
      }

      // 提前提取勾选数据的委托号数组
      const entrustNums = this.selectedRows.map(row => row.entrustNum)

      // 撤销派单确认
      this.$confirm('确认要撤销选中的派单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用撤销派单API
        const params = {
          entrustNums
        }

        backEntrustTask(params)
          .then(res => {
            if (res && res.retCode === 'ok') {
              this.$message.success('撤销派单成功')
              this.handleQuery() // 刷新列表
            } else {
              this.$message.error(res.retMsg || '撤销派单失败')
            }
          })
          .catch(err => {
            this.$message.error('撤销派单失败：' + (err.message || '网络错误'))
          })
      }).catch(() => {
        // 用户取消操作
        this.$message.info('已取消撤销操作')
      })
    },
    // 加载所有在职员工列表（用于搜索条件）
    loadAllEmployees () {
      const params = {
        pageSize: 500,
        currPage: 1,
        sginType: 'Test', // 查询有检测权限的员工
        employeeState: '1' // 只查询在职员工
      }

      queryEmployee(params)
        .then(res => {
          if (res && res.dataList) {
            this.searchEmployeeList = res.dataList || []
          }
        })
        .catch(err => {
          console.error('查询员工列表失败:', err)
        })
    },
    // 根据报告类型列表加载有权限的员工列表（查询交集）
    loadEmployeeListByReports (configReportPids) {
      // 如果正在加载，则不重复加载
      if (this.employeeLoading) {
        return
      }

      // 清空之前的员工列表
      this.employeeList = []

      // 如果只有一个报告类型，直接查询
      if (configReportPids.length === 1) {
        this.loadEmployeeListByReport(configReportPids[0])
        return
      }

      // 多个报告类型：分别查询每个报告的员工列表，然后取交集
      this.employeeLoading = true

      const promises = configReportPids.map(configReportPid => {
        const params = {
          pageSize: 1000,
          currPage: 1,
          configReportPid: configReportPid,
          sginType: 'Test',
          employeeState: '1'
        }
        return queryEmployee(params)
      })

      Promise.all(promises)
        .then(results => {
          // 获取所有结果的员工列表
          const employeeLists = results.map(res => res.dataList || [])

          // 如果有任何一个查询失败或为空，则没有交集
          if (employeeLists.some(list => list.length === 0)) {
            this.employeeList = []
            this.$message.warning('没有找到同时拥有所有选中报告检测权限的员工')
            this.employeeLoading = false
            return
          }

          // 计算交集：找出在所有列表中都存在的员工
          const firstList = employeeLists[0]
          const intersection = firstList.filter(employee => {
            // 检查该员工是否在所有其他列表中都存在
            return employeeLists.every(list =>
              list.some(e => e.employeePid === employee.employeePid)
            )
          })

          this.employeeList = intersection

          if (this.employeeList.length === 0) {
            this.$message.warning(`没有找到同时拥有所有选中报告（共${configReportPids.length}个）检测权限的员工`)
          } else {
            this.$message.success(`找到${this.employeeList.length}名同时拥有所有选中报告检测权限的员工`)
          }

          this.employeeLoading = false
        })
        .catch(err => {
          this.$message.error('获取职员列表失败：' + (err.message || '网络错误'))
          this.employeeList = []
          this.employeeLoading = false
        })
    },
    // 根据单个报告类型加载有权限的员工列表
    loadEmployeeListByReport (configReportPid) {
      // 如果正在加载，则不重复加载
      if (this.employeeLoading) {
        return
      }

      // 清空之前的员工列表
      this.employeeList = []
      this.employeeLoading = true

      const params = {
        pageSize: 1000,
        currPage: 1,
        configReportPid: configReportPid, // 报告类型ID
        sginType: 'Test', // 固定传 Test（检测权限）
        employeeState: '1' // 只查询在职员工
      }

      console.log('查询员工参数:', params)

      queryEmployee(params)
        .then(res => {
          console.log('查询员工响应:', res)
          if (res && res.dataList) {
            this.employeeList = res.dataList || []
            if (this.employeeList.length === 0) {
              this.$message.warning('没有找到有该报告检测权限的员工')
            }
          } else {
            this.$message.error(res.retMsg || '获取职员列表失败')
            this.employeeList = []
          }
          this.employeeLoading = false
        })
        .catch(err => {
          console.error('查询员工失败:', err)
          this.$message.error('获取职员列表失败：' + (err.message || '网络错误'))
          this.employeeList = []
          this.employeeLoading = false
        })
    },
    // 动态更新派单表单验证规则
    updateDispatchRules () {
      if (this.isPreDispatch) {
        // 预派单：预检日期必填，人员非必填
        this.dispatchRules = {
          estimatedDate: [
            { required: true, message: '请选择预检日期', trigger: 'change' }
          ],
          orderDate: [
            { required: true, message: '请选择派单日期', trigger: 'change' }
          ],
          employeePids: []
        }
      } else if (this.isAllPreDispatch) {
        // 全是预派单（场景1、2）：预检日期选填，人员必填
        this.dispatchRules = {
          estimatedDate: [],
          orderDate: [
            { required: true, message: '请选择派单日期', trigger: 'change' }
          ],
          employeePids: [
            { required: true, message: '请选择职员', trigger: 'change' }
          ]
        }
      } else {
        // 混合派单或全是未预派单：预检日期必填，人员必填
        this.dispatchRules = {
          estimatedDate: [
            { required: true, message: '请选择预检日期', trigger: 'change' }
          ],
          orderDate: [
            { required: true, message: '请选择派单日期', trigger: 'change' }
          ],
          employeePids: [
            { required: true, message: '请选择职员', trigger: 'change' }
          ]
        }
      }
    },
    // 关闭派单弹窗
    closeDispatchDialog () {
      this.dispatchDialogVisible = false
      // 手动重置表单数据，避免 resetFields 导致数组变为 undefined
      this.dispatchForm = {
        entrustNum: '',
        entrustNumArray: [],
        estimatedDate: '',
        orderDate: '',
        employeePids: []
      }
      this.$refs.dispatchForm.clearValidate()
    },
    // 确认派单
    confirmDispatch () {
      this.$refs.dispatchForm.validate((valid) => {
        if (valid) {
          this.dispatchLoading = true

          const params = {
            // 使用数组格式提交委托号
            entrustNums: this.dispatchForm.entrustNumArray,
            estimatedDate: this.dispatchForm.estimatedDate,
            orderDate: this.dispatchForm.orderDate,
            employeePids: this.dispatchForm.employeePids
          }

          // 根据模式调用不同的 API
          const apiCall = this.isPreDispatch ? saveEntrustTask(params) : dispatchTask(params)
          const successMsg = this.isPreDispatch ? '预派单成功' : '派单成功'
          const errorMsg = this.isPreDispatch ? '预派单失败' : '派单失败'

          apiCall
            .then(res => {
              if (res && res.retCode === 'ok') {
                this.$message.success(res.retMsg || successMsg)
                this.closeDispatchDialog()
                this.handleQuery() // 重新查询数据
              } else {
                this.$message.error(res.retMsg || errorMsg)
              }
              this.dispatchLoading = false
            })
            .catch(err => {
              this.$message.error(errorMsg + '：' + (err.message || '网络错误'))
              this.dispatchLoading = false
            })
        }
      })
    },
    handleEdit (row) {
      // 修改逻辑
      this.$refs.addAndEdit.showEdit(row)
    },
    // 处理表格选择变化
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    // 处理区域选择变化
    handleAreaChange (value) {
      // ChinaAreaCascader 多选时返回字符串数组，例如 ['福建省/福州市/仓山区/上街镇']
      if (!Array.isArray(value) || value.length === 0) {
        this.queryParams.EQP_AREA_NAME = ''
        return
      }
      this.queryParams.EQP_AREA_NAME = value.join(',')
    }
  }
};
</script>

<style scoped>
/* 这里可以添加样式 */
.pre-dispatch-dates {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.dispatch-hint {
  margin-top: 8px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>